(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["Persona"] = factory(require("react"), require("react-dom"), require("styled-components"));
	else
		root["Persona"] = factory(root["react"], root["react-dom"], root["styled-components"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_styled_components__) {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/dasherize/index.js":
/*!*****************************************!*\
  !*** ./node_modules/dasherize/index.js ***!
  \*****************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module */
/*! CommonJS bailout: module.exports is used directly at 70:0-14 */
/***/ ((module) => {



var isArray = Array.isArray || function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

var isDate = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var isRegex = function (obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var has = Object.prototype.hasOwnProperty;
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (has.call(obj, key)) {
      keys.push(key);
    }
  }
  return keys;
};

function dashCase(str) {
  return str.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, function (s, i) {
    return (i > 0 ? '-' : '') + s.toLowerCase();
  });
}

function map(xs, f) {
  if (xs.map) {
    return xs.map(f);
  }
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

function reduce(xs, f, acc) {
  if (xs.reduce) {
    return xs.reduce(f, acc);
  }
  for (var i = 0; i < xs.length; i++) {
    acc = f(acc, xs[i], i);
  }
  return acc;
}

function walk(obj) {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }
  if (isDate(obj) || isRegex(obj)) {
    return obj;
  }
  if (isArray(obj)) {
    return map(obj, walk);
  }
  return reduce(objectKeys(obj), function (acc, key) {
    var camel = dashCase(key);
    acc[camel] = walk(obj[key]);
    return acc;
  }, {});
}

module.exports = function (obj) {
  if (typeof obj === 'string') {
    return dashCase(obj);
  }
  return walk(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/*!****************************************!*\
  !*** ./node_modules/qs/lib/formats.js ***!
  \****************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module */
/*! CommonJS bailout: module.exports is used directly at 6:0-14 */
/***/ ((module) => {



var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/index.js ***!
  \**************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module, __webpack_require__ */
/*! CommonJS bailout: module.exports is used directly at 7:0-14 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var stringify = __webpack_require__(/*! ./stringify */ "./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__(/*! ./parse */ "./node_modules/qs/lib/parse.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/parse.js ***!
  \**************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module, __webpack_require__ */
/*! CommonJS bailout: module.exports is used directly at 222:0-14 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/*!******************************************!*\
  !*** ./node_modules/qs/lib/stringify.js ***!
  \******************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module, __webpack_require__ */
/*! CommonJS bailout: module.exports is used directly at 192:0-14 */
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    formatter: formats.formatters[formats['default']],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/utils.js ***!
  \**************************************/
/*! unknown exports (runtime-defined) */
/*! runtime requirements: module */
/*! CommonJS bailout: module.exports is used directly at 220:0-14 */
/***/ ((module) => {



var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),

/***/ "./src/components/ClientPopup.tsx":
/*!****************************************!*\
  !*** ./src/components/ClientPopup.tsx ***!
  \****************************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../lib/container */ "./src/lib/container.ts");
/* harmony import */ var _lib_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../lib/styles */ "./src/lib/styles.ts");
/* harmony import */ var _InquiryInternal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./InquiryInternal */ "./src/components/InquiryInternal.tsx");
/* harmony import */ var _LoadingSpinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./LoadingSpinner */ "./src/components/LoadingSpinner.tsx");
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};






var OVERLAY_OPACITY = 0.7;
var fadeIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    background-color: rgba(0, 0, 0, 0);\n    opacity: 0;\n  }\n  to {\n    background-color: rgba(0, 0, 0, ", ");\n    opacity: 1;\n  }\n"], ["\n  from {\n    background-color: rgba(0, 0, 0, 0);\n    opacity: 0;\n  }\n  to {\n    background-color: rgba(0, 0, 0, ", ");\n    opacity: 1;\n  }\n"])), OVERLAY_OPACITY);
var Overlay = styled_components__WEBPACK_IMPORTED_MODULE_1___default()('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation: ", " 0.3s;\n  background-color: rgba(0, 0, 0, ", ");\n  display: ", ";\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n"], ["\n  animation: ", " 0.3s;\n  background-color: rgba(0, 0, 0, ", ");\n  display: ", ";\n\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 9999;\n"])), fadeIn, OVERLAY_OPACITY, function (props) { return props.isOpen ? 'block' : 'none'; });
var CenteredFrame = styled_components__WEBPACK_IMPORTED_MODULE_1___default()('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 120px;\n  height: 120px;\n  position: absolute;\n  left: calc(50% - 60px);\n  top: calc(50% - 60px);\n  z-index: 9999;\n"], ["\n  width: 120px;\n  height: 120px;\n  position: absolute;\n  left: calc(50% - 60px);\n  top: calc(50% - 60px);\n  z-index: 9999;\n"])));
var genieSlideIn = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.keyframes)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from {\n    transform: translate(-50%, -40%) scale(.8);\n  }\n  90% {\n    transform: translate(-50%, -51%) scale(1.01);\n  }\n  to {\n    transform: translate(-50%, -50%);\n  }\n"], ["\n  from {\n    transform: translate(-50%, -40%) scale(.8);\n  }\n  90% {\n    transform: translate(-50%, -51%) scale(1.01);\n  }\n  to {\n    transform: translate(-50%, -50%);\n  }\n"])));
var slideDown = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.keyframes)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  from {\n    transform: translate(-50%, -55%);\n  }\n  to {\n    transform: translate(-50%, -50%);\n  }\n"], ["\n  from {\n    transform: translate(-50%, -55%);\n  }\n  to {\n    transform: translate(-50%, -50%);\n  }\n"])));
var IframeAnimatePopup = styled_components__WEBPACK_IMPORTED_MODULE_1___default()('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  iframe {\n    animation: ", " 0.3s, ", " ease-out 0.3s;\n\n    width: 100%;\n    height: 100%;\n\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    background-color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0px 12px 40px 2px rgba(0, 0, 0, 0.4);\n\n    @media only screen and (min-width: 600.02px) and (min-height: 600.02px) {\n      max-width: 400px;\n      max-height: 650px;\n    }\n  }\n"], ["\n  iframe {\n    animation: ", " 0.3s, ", " ease-out 0.3s;\n\n    width: 100%;\n    height: 100%;\n\n    margin-left: auto;\n    margin-right: auto;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n    background-color: #ffffff;\n    border: none;\n    border-radius: 4px;\n    box-shadow: 0px 12px 40px 2px rgba(0, 0, 0, 0.4);\n\n    @media only screen and (min-width: 600.02px) and (min-height: 600.02px) {\n      max-width: 400px;\n      max-height: 650px;\n    }\n  }\n"])), genieSlideIn, slideDown);
var OpenGlobalStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.createGlobalStyle)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  // Don't allow scrolling when widget is open\n  html body {\n    overflow: hidden !important;\n  }\n\n  // When the widget takes the full screen, hide everything else to prevent iOS scroll issues.\n  @media ", " {\n    html body > *:not(#", ") {\n      display: none !important;\n    }\n  }\n"], ["\n  // Don't allow scrolling when widget is open\n  html body {\n    overflow: hidden !important;\n  }\n\n  // When the widget takes the full screen, hide everything else to prevent iOS scroll issues.\n  @media ", " {\n    html body > *:not(#", ") {\n      display: none !important;\n    }\n  }\n"])), _lib_styles__WEBPACK_IMPORTED_MODULE_2__.MEDIA_QUERIES.isMobile, function (props) { return props.containerId; });
var ClientPopup = function (props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Overlay, { isOpen: props.isOpen },
        props.isLoading && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(CenteredFrame, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LoadingSpinner__WEBPACK_IMPORTED_MODULE_3__.default, null))),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(IframeAnimatePopup, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InquiryInternal__WEBPACK_IMPORTED_MODULE_4__.default, __assign({}, props, { onExit: props.onExit, containerId: props.containerId, refIframe: props.refIframe, flowType: _lib_container__WEBPACK_IMPORTED_MODULE_5__.FlowType.Embedded }))),
        props.isOpen && react__WEBPACK_IMPORTED_MODULE_0__.createElement(OpenGlobalStyle, { containerId: props.containerId })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ClientPopup);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;


/***/ }),

/***/ "./src/components/Inquiry.tsx":
/*!************************************!*\
  !*** ./src/components/Inquiry.tsx ***!
  \************************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _lib_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../lib/container */ "./src/lib/container.ts");
/* harmony import */ var _InquiryInternal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./InquiryInternal */ "./src/components/InquiryInternal.tsx");
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (props) {
    var _a = __read(react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_lib_container__WEBPACK_IMPORTED_MODULE_1__.newContainerId)()), 2), containerId = _a[0], _ = _a[1];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_InquiryInternal__WEBPACK_IMPORTED_MODULE_2__.default, __assign({}, props, { containerId: containerId, flowType: _lib_container__WEBPACK_IMPORTED_MODULE_1__.FlowType.Inline })));
});


/***/ }),

/***/ "./src/components/InquiryInternal.tsx":
/*!********************************************!*\
  !*** ./src/components/InquiryInternal.tsx ***!
  \********************************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dasherize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! dasherize */ "./node_modules/dasherize/index.js");
/* harmony import */ var dasherize__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dasherize__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../package.json */ "./package.json");
/* harmony import */ var _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../lib/interfaces */ "./src/lib/interfaces.ts");





/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (props) {
    // User error handling
    if (!props.templateId && !props.inquiryId) {
        throw new Error('Either templateId or inquiryId must be specified to start a flow');
    }
    if (props.templateId && props.inquiryId) {
        throw new Error('Only one of templateId or inquiryId should be specified to start a flow');
    }
    if (props.referenceId && props.accountId) {
        throw new Error('Only one of referenceId or accountId should be specified');
    }
    // Setup message handling
    var baseUrl;
    switch (props.host) {
        case 'development':
            baseUrl = 'http://localhost:3000';
            break;
        case 'staging':
            baseUrl = 'https://withpersona-staging.com';
            break;
        default:
            baseUrl = 'https://withpersona.com';
            break;
    }
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
        var handleMessage = function (event) {
            var templateId = props.templateId;
            if ((event.origin !== baseUrl && event.origin !== '') ||
                event.data.templateId !== templateId) {
                return;
            }
            if (event.data.containerId && props.containerId !== event.data.containerId) {
                // Use containerId as way to determine which client (if multiple instantiated on a page) a message came from.
                return;
            }
            props.onEvent && props.onEvent(event.data.name, event.data.metadata);
            switch (event.data.name) {
                case _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__.Event.Load:
                    props.onLoad && props.onLoad(event.data.error);
                    break;
                case _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__.Event.Start:
                    props.onStart && props.onStart(event.data.metadata.inquiryId);
                    break;
                case _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__.Event.Complete:
                    props.onComplete && props.onComplete(event.data.metadata.inquiryId, event.data.metadata.scopes);
                    break;
                case _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__.Event.Fail:
                    props.onFail && props.onFail(event.data.metadata.inquiryId);
                    break;
                case _lib_interfaces__WEBPACK_IMPORTED_MODULE_3__.Event.Exit:
                    props.onExit && props.onExit(event.data.error, {});
                    break;
            }
        };
        window.addEventListener('message', handleMessage);
    }, []);
    var prefill = dasherize__WEBPACK_IMPORTED_MODULE_1__(props.prefill || {});
    var lockedAttributes = props.lockedAttributes || {};
    var queryParams = qs__WEBPACK_IMPORTED_MODULE_2__.stringify({
        'client-version': _package_json__WEBPACK_IMPORTED_MODULE_4__.version,
        'container-id': props.containerId,
        'template-id': props.templateId,
        environment: props.environment,
        'iframe-origin': window.location.origin,
        'inquiry-id': props.inquiryId,
        language: props.language,
        'session-token': props.accessToken,
        'reference-id': props.referenceId,
        'account-id': props.accountId,
        'theme-id': props.themeId,
        note: props.note,
        prefill: prefill,
        'locked-attributes': {
            'name-first': lockedAttributes.nameFirst,
            'name-last': lockedAttributes.nameLast,
            birthdate: lockedAttributes.birthdate,
            'address-street-1': lockedAttributes.addressStreet1,
            'address-street-2': lockedAttributes.addressStreet2,
            'address-city': lockedAttributes.addressCity,
            'address-subdivision': lockedAttributes.addressSubdivision,
            'address-postal-code': lockedAttributes.addressPostalCode,
            'country-code': lockedAttributes.countryCode,
            'phone-number': lockedAttributes.phoneNumber,
            'email-address': lockedAttributes.emailAddress,
        },
        'flow-type': props.flowType,
    }, { addQueryPrefix: true });
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("iframe", { allow: 'camera', sandbox: 'allow-same-origin allow-scripts allow-forms allow-popups allow-modals allow-top-navigation-by-user-activation', frameBorder: '0', ref: props.refIframe, src: baseUrl + '/widget' + queryParams, onLoad: function () {
            // TODO: check contents
        } }));
});


/***/ }),

/***/ "./src/components/LoadingSpinner.tsx":
/*!*******************************************!*\
  !*** ./src/components/LoadingSpinner.tsx ***!
  \*******************************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _images_loading_LoadingSvg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../images/loading/LoadingSvg */ "./src/images/loading/LoadingSvg.tsx");
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};



var rotating = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: translate(-50%,-50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%,-50%) rotate(360deg);\n  }\n"], ["\n  from {\n    transform: translate(-50%,-50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%,-50%) rotate(360deg);\n  }\n"])));
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1___default()('div')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 120px;\n  height: 120px;\n"], ["\n  position: relative;\n  width: 120px;\n  height: 120px;\n"])));
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function () {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_images_loading_LoadingSvg__WEBPACK_IMPORTED_MODULE_2__.default, null)));
});
var templateObject_1, templateObject_2;


/***/ }),

/***/ "./src/images/loading/LoadingSvg.tsx":
/*!*******************************************!*\
  !*** ./src/images/loading/LoadingSvg.tsx ***!
  \*******************************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};


var rotating = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    transform: translate(-50%,-50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%,-50%) rotate(360deg);\n  }\n"], ["\n  from {\n    transform: translate(-50%,-50%) rotate(0deg);\n  }\n  to {\n    transform: translate(-50%,-50%) rotate(360deg);\n  }\n"])));
var SpinningSvg = styled_components__WEBPACK_IMPORTED_MODULE_1___default()('svg')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: ", " 5s linear infinite;\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: ", " 5s linear infinite;\n"])), rotating);
function LoadingSvg() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SpinningSvg, { xmlns: 'http://www.w3.org/2000/svg', width: '114', height: '114' },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: 'none', stroke: '#0F2B72', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '2', d: 'M25.887 10.432a56.275 56.275 0 0 0-15.455 15.455 55.86 55.86 0 0 0-5.183 9.678A55.576 55.576 0 0 0 2.066 46.07m-.8 5.438A56.678 56.678 0 0 0 1 57m4.249 21.435a55.86 55.86 0 0 0 5.183 9.678 56.275 56.275 0 0 0 6.97 8.485m8.485 6.97a55.86 55.86 0 0 0 9.678 5.183 55.576 55.576 0 0 0 10.506 3.183c3.535.7 7.19 1.066 10.929 1.066 3.74 0 7.394-.367 10.929-1.066a55.576 55.576 0 0 0 10.506-3.183 55.86 55.86 0 0 0 9.678-5.183 56.275 56.275 0 0 0 15.455-15.455 55.86 55.86 0 0 0 5.183-9.678 55.576 55.576 0 0 0 3.183-10.506A56.274 56.274 0 0 0 113 57c0-3.74-.367-7.394-1.066-10.929a55.576 55.576 0 0 0-3.183-10.506M96.598 17.402a56.275 56.275 0 0 0-8.485-6.97 55.86 55.86 0 0 0-9.678-5.183A55.576 55.576 0 0 0 67.93 2.066 56.274 56.274 0 0 0 57 1c-3.74 0-7.394.367-10.929 1.066m-34.94 30.418A51.76 51.76 0 0 0 7.225 41.9a51.633 51.633 0 0 0-1.98 10 52.63 52.63 0 0 0 .744 15.247 51.633 51.633 0 0 0 7.768 18.743 52.188 52.188 0 0 0 10.254 11.308 52.188 52.188 0 0 0 8.472 5.67m9.417 3.905a51.633 51.633 0 0 0 10 1.98 52.63 52.63 0 0 0 10.197 0 51.939 51.939 0 0 0 10-1.98 51.61 51.61 0 0 0 9.418-3.904 51.984 51.984 0 0 0 8.472-5.671m3.782-3.43a52.308 52.308 0 0 0 3.429-3.78m9.575-17.89a51.633 51.633 0 0 0 1.98-10 52.63 52.63 0 0 0-.744-15.247 51.633 51.633 0 0 0-7.768-18.743 52.188 52.188 0 0 0-10.254-11.308m-4.097-3.043a51.984 51.984 0 0 0-4.375-2.628M67.148 5.99a51.939 51.939 0 0 0-5.05-.743 52.63 52.63 0 0 0-15.246.743 51.633 51.633 0 0 0-18.743 7.768M24.012 16.8a52.308 52.308 0 0 0-3.782 3.43' })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LoadingSvg);
var templateObject_1, templateObject_2;


/***/ }),

/***/ "./src/lib/Client.tsx":
/*!****************************!*\
  !*** ./src/lib/Client.tsx ***!
  \****************************/
/*! namespace exports */
/*! export default [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__, __webpack_require__.n, __webpack_exports__, __webpack_require__.r, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_ClientPopup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/ClientPopup */ "./src/components/ClientPopup.tsx");
/* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./container */ "./src/lib/container.ts");
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};




/**
 * Wraps the Inquiry iframe with embedded modal event / action handling.
 */
var Client = /** @class */ (function () {
    function Client(options) {
        var _this = this;
        this._isLoading = true;
        this._isOpen = false;
        this.onLoad = function (error) {
            _this._isLoading = false;
            _this.render();
            _this.options.onLoad && _this.options.onLoad(error);
        };
        this.onComplete = function (inquiryId, scopes) {
            _this._isOpen = false;
            _this.render();
            _this.options.onComplete &&
                _this.options.onComplete(inquiryId, scopes);
        };
        this.onFail = function (inquiryId) {
            _this._isOpen = false;
            _this.render();
            _this.options.onFail && _this.options.onFail(inquiryId);
        };
        this.onExit = function (error, metadata) {
            _this._isOpen = false;
            _this.render();
            _this.options.onExit && _this.options.onExit(error, metadata);
        };
        this.options = options;
        this.refIframe = react__WEBPACK_IMPORTED_MODULE_0__.createRef();
        // Create container div
        this.container = document.createElement('div');
        this.containerId = (0,_container__WEBPACK_IMPORTED_MODULE_2__.newContainerId)();
        this.container.setAttribute('id', this.containerId);
        if (document.body) {
            document.body.appendChild(this.container);
        }
        else {
            document.children[0].appendChild(this.container);
        }
        this.render();
    }
    Client.prototype.render = function () {
        react_dom__WEBPACK_IMPORTED_MODULE_1__.render(react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_ClientPopup__WEBPACK_IMPORTED_MODULE_3__.default, __assign({ isLoading: this._isLoading, isOpen: this._isOpen, containerId: this.containerId, refIframe: this.refIframe }, this.options, { 
            // Override event handlers in options to capture popup interactions
            onLoad: this.onLoad, onStart: this.options.onStart, onComplete: this.onComplete, onFail: this.onFail, onExit: this.onExit, onEvent: this.options.onEvent })), this.container);
    };
    Client.prototype.open = function () {
        this._isOpen = true;
        this.render();
    };
    Client.prototype.exit = function (force) {
        if (this.refIframe.current) {
            this.refIframe.current.contentWindow.postMessage({
                action: 'exit',
                metadata: { force: force },
            }, this.baseUrl);
        }
        this.render();
    };
    Object.defineProperty(Client.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Client.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    return Client;
}());
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Client);


/***/ }),

/***/ "./src/lib/container.ts":
/*!******************************!*\
  !*** ./src/lib/container.ts ***!
  \******************************/
/*! namespace exports */
/*! export FlowType [provided] [no usage info] [missing usage info prevents renaming] */
/*! export newContainerId [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__.r, __webpack_exports__, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "newContainerId": () => /* binding */ newContainerId,
/* harmony export */   "FlowType": () => /* binding */ FlowType
/* harmony export */ });
// This ID is used to tie window posted messages to a specific container / inquiry.
function newContainerId() {
    return 'persona-widget-' +
        new Array(16)
            .fill(undefined)
            .map(function () { return Math.floor(Math.random() * 35).toString(35); })
            .join('');
}
var FlowType;
(function (FlowType) {
    FlowType["Embedded"] = "embedded";
    FlowType["Inline"] = "inline";
})(FlowType || (FlowType = {}));


/***/ }),

/***/ "./src/lib/interfaces.ts":
/*!*******************************!*\
  !*** ./src/lib/interfaces.ts ***!
  \*******************************/
/*! namespace exports */
/*! export Event [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__.r, __webpack_exports__, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Event": () => /* binding */ Event
/* harmony export */ });
/**
 * Events sent from the persona-web iframe.
 */
var Event;
(function (Event) {
    Event["Error"] = "error";
    Event["Exit"] = "exit";
    Event["Complete"] = "complete";
    Event["Fail"] = "fail";
    Event["Load"] = "load";
    Event["Start"] = "start";
    Event["Success"] = "success";
    Event["InquiryLoad"] = "inquiry-load";
    Event["CountrySelect"] = "country-select";
    Event["VerificationSelect"] = "verification-select";
    Event["VerificationChange"] = "verification-change";
    Event["DocumentCameraSelect"] = "document-camera-select";
    Event["DocumentCameraCapture"] = "document-camera-capture";
    Event["DocumentUpload"] = "document-upload";
    Event["OneTimeLinkSent"] = "one-time-link-sent";
    Event["OneTimeLinkStart"] = "one-time-link-start";
    Event["OneTimeLinkExit"] = "one-time-link-exit";
    Event["SelfieRecordUpload"] = "selfie-record-upload";
})(Event || (Event = {}));


/***/ }),

/***/ "./src/lib/styles.ts":
/*!***************************!*\
  !*** ./src/lib/styles.ts ***!
  \***************************/
/*! namespace exports */
/*! export MEDIA_QUERIES [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_require__.r, __webpack_exports__, __webpack_require__.d, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MEDIA_QUERIES": () => /* binding */ MEDIA_QUERIES
/* harmony export */ });
// This doesn't match page widths because we want
// some pages to be smaller than mobile sizes on desktop.
var MEDIA_QUERIES = {
    isMobile: '(max-width: 600px), (max-height: 420px)',
    // Add 0.02 to width so it doesn't overlap with mobile width, this is bootstrap's approach
    isNotMobile: '(min-width: 600.02px) and (min-height: 420.02px)',
};


/***/ }),

/***/ "./src/persona.ts":
/*!************************!*\
  !*** ./src/persona.ts ***!
  \************************/
/*! namespace exports */
/*! export Client [provided] [no usage info] [missing usage info prevents renaming] -> ./src/lib/Client.tsx .default */
/*! export Inquiry [provided] [no usage info] [missing usage info prevents renaming] -> ./src/components/Inquiry.tsx .default */
/*! export default [provided] [used in persona] [usage prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: __webpack_exports__, __webpack_require__, __webpack_require__.d, __webpack_require__.r, __webpack_require__.* */
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => __WEBPACK_DEFAULT_EXPORT__,
/* harmony export */   "Client": () => /* reexport safe */ _lib_Client__WEBPACK_IMPORTED_MODULE_0__.default,
/* harmony export */   "Inquiry": () => /* reexport safe */ _components_Inquiry__WEBPACK_IMPORTED_MODULE_1__.default
/* harmony export */ });
/* harmony import */ var _lib_Client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./lib/Client */ "./src/lib/Client.tsx");
/* harmony import */ var _components_Inquiry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/Inquiry */ "./src/components/Inquiry.tsx");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    Client: _lib_Client__WEBPACK_IMPORTED_MODULE_0__.default,
    Inquiry: _components_Inquiry__WEBPACK_IMPORTED_MODULE_1__.default,
});
// Support named imports
// eg: import { Client } from 'persona'



/***/ }),

/***/ "./package.json":
/*!**********************!*\
  !*** ./package.json ***!
  \**********************/
/*! default exports */
/*! export author [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export email [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export name [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export dependencies [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export core-js [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export dasherize [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export qs [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export description [provided] [no usage info] [missing usage info prevents renaming] */
/*! export devDependencies [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @babel/preset-env [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @team-griffin/install-self-peers [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @types/jest [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @types/qs [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @types/react [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @types/react-dom [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @types/styled-components [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export @wojtekmaj/enzyme-adapter-react-17 [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export babel-loader [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export conventional-changelog-core [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export cypress [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export enzyme [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export jest [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export prettier [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export react-svg-loader [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export source-map-loader [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export standard-version [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export ts-jest [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export ts-loader [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export typescript [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export webpack [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export webpack-bundle-analyzer [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export webpack-cli [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export files [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export 0 [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export 1 [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export jest [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export globals [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export ts-jest [provided] [no usage info] [missing usage info prevents renaming] */
/*!       export tsConfig [provided] [no usage info] [missing usage info prevents renaming] */
/*!       other exports [not provided] [no usage info] */
/*!     other exports [not provided] [no usage info] */
/*!   export moduleDirectories [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 0 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 1 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   export moduleFileExtensions [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 0 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 1 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 2 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 3 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   export moduleNameMapper [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export \\.(svg)$ [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   export roots [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 0 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   export setupFilesAfterEnv [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export 0 [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   export testURL [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export transform [provided] [no usage info] [missing usage info prevents renaming] */
/*!     export ^.+\\.(ts|tsx)$ [provided] [no usage info] [missing usage info prevents renaming] */
/*!     other exports [not provided] [no usage info] */
/*!   other exports [not provided] [no usage info] */
/*! export license [provided] [no usage info] [missing usage info prevents renaming] */
/*! export main [provided] [no usage info] [missing usage info prevents renaming] */
/*! export name [provided] [no usage info] [missing usage info prevents renaming] */
/*! export peerDependencies [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export react [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export react-dom [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export styled-components [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export scripts [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export cypress:open [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export cypress:run [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export installPeers [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export prepublishOnly [provided] [no usage info] [missing usage info prevents renaming] */
/*!   export watch [provided] [no usage info] [missing usage info prevents renaming] */
/*!   other exports [not provided] [no usage info] */
/*! export sideEffects [provided] [no usage info] [missing usage info prevents renaming] */
/*! export types [provided] [no usage info] [missing usage info prevents renaming] */
/*! export version [provided] [no usage info] [missing usage info prevents renaming] */
/*! other exports [not provided] [no usage info] */
/*! runtime requirements: module */
/***/ ((module) => {

module.exports = JSON.parse("{\"name\":\"persona\",\"version\":\"3.7.3\",\"description\":\"The official web client library for the Persona API.\",\"main\":\"./dist/persona.js\",\"types\":\"./dist/persona.d.ts\",\"author\":{\"name\":\"Persona Identities, Inc.\",\"email\":\"support@withpersona.com\"},\"license\":\"MIT\",\"sideEffects\":false,\"scripts\":{\"installPeers\":\"yarn && install-self-peers -- --ignore-scripts\",\"prepublishOnly\":\"yarn tsc && yarn webpack --mode=production\",\"watch\":\"webpack --watch\",\"cypress:open\":\"TZ=Etc/UTC cypress open\",\"cypress:run\":\"TZ=Etc/UTC cypress run\"},\"dependencies\":{\"core-js\":\"^3.0.0\",\"dasherize\":\"^2.0.0\",\"qs\":\"^6.7.0\"},\"devDependencies\":{\"@babel/preset-env\":\"^7.4.2\",\"@team-griffin/install-self-peers\":\"1.1.1\",\"@types/jest\":\"^24.0.5\",\"@types/qs\":\"^6.5.3\",\"@types/react\":\"^16.8.2\",\"@types/react-dom\":\"^16.8.0\",\"@types/styled-components\":\"^4.1.9\",\"@wojtekmaj/enzyme-adapter-react-17\":\"^0.4.1\",\"babel-loader\":\"^8.0.5\",\"conventional-changelog-core\":\"^4.1.4\",\"cypress\":\"^6.0.0\",\"enzyme\":\"^3.11.0\",\"jest\":\"^24.1.0\",\"prettier\":\"^2.2.1\",\"react-svg-loader\":\"^3.0.3\",\"source-map-loader\":\"^0.2.4\",\"standard-version\":\"^7.1.0\",\"ts-jest\":\"^26.4.4\",\"ts-loader\":\"^8.0.9\",\"typescript\":\"^4.0.5\",\"webpack\":\"^5.0.0-rc.6\",\"webpack-bundle-analyzer\":\"^3.9.0\",\"webpack-cli\":\"^4.2.0\"},\"files\":[\"dist/persona.js\",\"dist/**/*.d.ts\"],\"peerDependencies\":{\"react\":\">= 16\",\"react-dom\":\">= 16\",\"styled-components\":\">= 4\"},\"jest\":{\"roots\":[\"src\"],\"moduleDirectories\":[\"node_modules\",\"./\"],\"moduleFileExtensions\":[\"ts\",\"tsx\",\"js\",\"json\"],\"moduleNameMapper\":{\"\\\\.(svg)$\":\"<rootDir>/src/spec/svgMock.tsx\"},\"setupFilesAfterEnv\":[\"<rootDir>/src/spec/setupTests.ts\"],\"testURL\":\"http://localhost\",\"transform\":{\"^.+\\\\.(ts|tsx)$\":\"ts-jest\"},\"globals\":{\"ts-jest\":{\"tsConfig\":\"tsconfig.json\"}}}}");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! dynamic exports */
/*! export __esModule [maybe provided (runtime-defined)] [no usage info] [provision prevents renaming (no use info)] */
/*! other exports [maybe provided (runtime-defined)] [no usage info] */
/*! runtime requirements: module */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/*!****************************!*\
  !*** external "react-dom" ***!
  \****************************/
/*! dynamic exports */
/*! export __esModule [maybe provided (runtime-defined)] [no usage info] [provision prevents renaming (no use info)] */
/*! other exports [maybe provided (runtime-defined)] [no usage info] */
/*! runtime requirements: module */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/*! dynamic exports */
/*! export __esModule [maybe provided (runtime-defined)] [no usage info] [provision prevents renaming (no use info)] */
/*! other exports [maybe provided (runtime-defined)] [no usage info] */
/*! runtime requirements: module */
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => module['default'] :
/******/ 				() => module;
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__("./src/persona.ts");
/******/ })()
.default;
});